// extracted by mini-css-extract-plugin
export var logo = "_kq-2";
export var logoWrapper = "_kq-1";
export var strip = "_kq-0";